/* eslint-disable */
const $request = (function () {
  const $ = window.$, ctx = window.APPLICATION_CONTEXT;
  return {
    post(url) {
      return new Promise(function (resolve) {
        $.post(ctx + url, resolve);
      });
    },
  };
})();

export function getPublicChannel() {
  return new Promise(resolve => {
    if (process.env.NODE_ENV === 'production') {
      $request.post('/svs/client/getPublicChannel.json').then(res => {
        resolve(res.data);
      });
    } else {
      resolve({
        roles: [],
      });
    }
  });
}

const MEMBER_NAME_MAP = {};

export function getMemberName(accountId) {
  return MEMBER_NAME_MAP[accountId];
}

export function setMemberName(accountId, name) {
  MEMBER_NAME_MAP[accountId] = name;
}

export function getMemberMetaInfo(accountId) {
  const name = getMemberName(accountId);
  return name ? Promise.resolve(name) : new Promise((resolve => {
    $request.post('/svs/client/getMemberName.json?id=' + accountId).then(res => {
      MEMBER_NAME_MAP[accountId] = res.data;
      resolve(res.data);
    });
  }));
}